export default __webpack_public_path__ + "static/media/brainstorming-best-practices.ba205431.pdf";